export const QK_HOMEPAGE = '/settings/homepage'
